export default Object.freeze({
  // CONTRACT_DOWNLOAD
  CONTRACT_TITLE: '계약 서류 정보',

  NOTICE_1: 'ⓘ 파트너 어드민 등록 시 파트너사에서 등록한 계약 서류를 확인/변경할 수 있습니다.',
  NOTICE_2: 'ⓘ 모든 계약 서류는 정보 보안에 유의하여 관리해주세요.',
  NOTICE_3: 'ⓘ [파일변경] 버튼을 클릭하여 파일 업로드 시 기존 파일은 삭제됩니다.',
  NOTICE_4: 'ⓘ 파일은 jpg, jpeg, png, pdf파일로 등록 가능하며, 용량은 1개/10MB미만 입니다.',

  TABLE_HEADER: '계약 서류',

  UPDATE_CONTRACT_FILE: '파일변경',
  ADD_CONTRACT_FILE: '파일등록',
  CONTRACT_DOWNLOAD: '다운로드',
  CONTRACT_DOWNLOAD_ALL: '전체 다운로드',

  ALERT_INCORRECT_FILE: '파일 확장자명을 확인해주세요.',
  DOMESTIC_DOCUMENT_0: '사업자등록증',
  DOMESTIC_DOCUMENT_1: '통장사본',
  DOMESTIC_DOCUMENT_2: '법인인감증명서',
  
  GLOBAL_DOCUMENT_0: '계좌증빙서',
  
  DOCUMENT: '서류',

  ALERT_UPDATE_CONTRACT_FILE: '기존에 등록된 파일은 영구삭제되며 복원이 불가능합니다. 계약 서류를 변경하시겠니까?',
  ALERT_UPDATE_CONTRACT_FILE_COMPLETE: '계약 서류가 변경되었습니다.',

  // 계약서류변경이력
  CONTRACT_FILE_UPDATE_HISTORY: '계약 서류 변경 이력',
  CHANGE_DATE: '번경일',
  CHANGE_CONTRACT_FILE_TITLE: '변경 계약 서류',
  ADMIN_ID: '운영자 ID',

   // 담당자 변경
  CHANGE_MD_TITLE: '담당자 변경',

  CHANGE_MD_NOTICE_1: '· 조회한 담당MD 운영자명에 따라 해당 운영자가 담당중인 파트너의 담당MD를 다른 운영자로 일괄변경할 수 있습니다.',
  CHANGE_MD_NOTICE_2: '· 해당 쇼핑몰에 권한이 있고 상품담당 권한이 있는 운영자에 한해 담당자 변경이 가능합니다.',

  CHANGE_MD_TABLE_HEADER_MALL: '거래 쇼핑몰',
  CHANGE_MD_TABLE_HEADER_CURRENT_MD: '기존 담당자',
  CHANGE_MD_TABLE_HEADER_CURRENT_PARTNER: '대상 파트너명',
  CHANGE_MD_TABLE_HEADER_CHANGE_PARTNER: '대상 파트너',
  CHANGE_MD_TABLE_HEADER_CHANGE_MD: '변경할 담당자',
  
  CHANGE_BTN: '변경',

  COUNT: '개',
  CHANGE_MD_MARK: '(으)로 담당자를 변경합니다.',

  ERR_MD_NULL: '변경할 담당자를 선택해주세요',
  CHANGE_CONFIRM_MESSAGE: '확인을 누르시면 즉시 담당자 변경이 진행됩니다. 변경하시겠습니까?',
  SUCCESS_MESSAGE: '성공 {0}건 {1}으로 변경완료',
  
})

